// extracted by mini-css-extract-plugin
export default {"container":"WorkgroupAccessRequestsList_container__Y3i8l","gridContainer":"WorkgroupAccessRequestsList_gridContainer__lvdG+"};